const isProduction = process.env.NODE_ENV === "production";
export const rootUrl = isProduction
  ? "https://partnerapi.mobiltracker.com.br/"
  : "http://localhost/Mobiltracker.Partner.Api/";
